export default __webpack_public_path__ + "static/media/StreetFighter.de0de6fa.jpg";